var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositLimitFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.657 2c-.295.468-.54.97-.728 1.5H3.5v6H6v-2H5A.75.75 0 015 6h5.5a7.5 7.5 0 007.5 7.5V21a1 1 0 01-1 1H7a1 1 0 01-1-1V11H3l-.103-.005A1 1 0 012 10V3a1 1 0 011-1h8.657zm.974 10.578a1 1 0 00-1.262 0l-.076.069L8.97 14.97a.75.75 0 101.06 1.06L12 14.06l1.97 1.97.056.052a.75.75 0 001.056-1.056l-.052-.056-2.323-2.324-.076-.068z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0a6 6 0 110 12 6 6 0 010-12zm0 8a.75.75 0 100 1.5.75.75 0 000-1.5zm0-5.45a.75.75 0 00-.75.75v3a.75.75 0 001.5 0v-3a.75.75 0 00-.75-.75z",
    fill: "currentColor"
  })));
}
SvgDepositLimitFilled.displayName = 'DepositLimitFilled';
export default SvgDepositLimitFilled;